<div class="post-trading-expired-orders">
	<app-table
		[statesColumns]="statesColumns()"
		[settings]="{
			size: 'md',
			spreadContent: 'space-between',
			rowBorder: true,
			emptyTextPath: 'postTrading.empty',
		}"
		[items]="postTradingEvents()"
		[isLoading]="isLoading()"
	>
		<app-table-column
			[settings]="{
				titlePath: 'postTrading.columns.option',
				column: columnsPostTradingExpiredEnum.option,
				minWidthPx: 210,
				maxWidthPx: 230,
				spreadContent: 'flex-start',
			}"
		>
			<ng-template let-item="item">
				<div class="ticker-column">
					<span class="text">{{ item.option_ticker }}</span>
					<span class="text">{{ item.option_strike | price }}</span>
					<span
						class="text"
						highlight
						[isPositive]="item.option_type === optionTypeEnum.CALL"
						[isNegative]="item.option_type === optionTypeEnum.PUT"
					>
						{{ item.option_type | uppercase }}
					</span>
					<span class="text">{{ item.option_date | date: 'dd.MM.yyyy' }}</span>
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'postTrading.columns.options',
				column: columnsPostTradingExpiredEnum.options,
				minWidthPx: 90,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					secret
					[isSecret]="isSecret()"
					[secretCount]="4"
					class="text"
					>{{ item.qty | quantity }}</span
				>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'postTrading.columns.stocks',
				column: columnsPostTradingExpiredEnum.stocks,
				minWidthPx: 90,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					class="text"
					secret
					[isSecret]="isSecret()"
					[secretCount]="4"
					highlight
					[isPositive]="(item.optrd_qty ?? 0) > 0"
					[isNegative]="(item.optrd_qty ?? 0) < 0"
					[isNeutral]="!item.optrd_qty"
				>
					{{ item.optrd_qty | quantity }}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'postTrading.columns.sum',
				column: columnsPostTradingExpiredEnum.sum,
				minWidthPx: 90,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					class="text"
					secret
					[isSecret]="isSecret()"
					[secretCount]="4"
					highlight
					[isPositive]="(item.optrd_net_amount ?? 0) > 0"
					[isNegative]="(item.optrd_net_amount ?? 0) < 0"
					[isNeutral]="!item.optrd_net_amount"
				>
					{{ item.optrd_net_amount | price }}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'postTrading.columns.price',
				column: columnsPostTradingExpiredEnum.price,
				minWidthPx: 90,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					secret
					[isSecret]="isSecret()"
					[secretCount]="4"
					class="text"
					>{{ item.optrd_price | price }}</span
				>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'postTrading.columns.event',
				column: columnsPostTradingExpiredEnum.event,
				minWidthPx: 90,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span class="text">{{ 'postTrading.events.' + item.entry_type | translate }}</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'postTrading.columns.date',
				column: columnsPostTradingExpiredEnum.date,
				minWidthPx: 90,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span class="text">{{ item.settle_date | date: 'dd.MM.yyyy' }}</span>
			</ng-template>
		</app-table-column>

		<app-table-actions>
			<ng-template let-item="item">
				<app-post-trading-expired-events-actions [event]="item" />
			</ng-template>
		</app-table-actions>

		<app-table-footer>
			<ng-template>
				<div class="footer">
					<div class="total">
						<span class="title">{{ 'postTrading.total' | translate }}:</span>
						<span
							class="value"
							[tuiSkeleton]="isLoading()"
							>{{ postTradingEvents().length | quantity }}</span
						>
					</div>
				</div>
			</ng-template>
		</app-table-footer>
	</app-table>
</div>
